(() => {
  'use strict';
  if (window.__ROCKY_RK4_POLISH__) return;
  window.__ROCKY_RK4_POLISH__ = true;

  const rk4FitLabCssReady = Promise.resolve();

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const mediaShells = root => {
    const shells = [];
    if (root?.matches?.('[data-rk4-media-shell]')) shells.push(root);
    root?.querySelectorAll?.('[data-rk4-media-shell]').forEach(shell => shells.push(shell));
    shells.forEach(shell => {
      if (shell.dataset.rk4MediaReady === 'true') return;
      shell.dataset.rk4MediaReady = 'true';
      const video = shell.querySelector('video');
      if (!video) return;
      if (reduceMotion) {
        shell.classList.add('is-reduced-motion');
        video.pause();
        return;
      }
      const ready = () => shell.classList.add('is-video-ready');
      const unavailable = () => {
        shell.classList.remove('is-video-ready');
        shell.classList.add('is-video-unavailable');
      };
      if (video.readyState >= 2) ready();
      else video.addEventListener('loadeddata', ready, { once: true });
      video.addEventListener('error', unavailable, { once: true });
      video.querySelector('source')?.addEventListener('error', unavailable, { once: true });
    });
  };

  const safeStockCopy = root => {
    const nodes = [];
    if (root?.matches?.('[data-rk4-stock]')) nodes.push(root);
    root?.querySelectorAll?.('[data-rk4-stock]').forEach(node => nodes.push(node));
    nodes.forEach(node => {
      if (node.textContent.includes('G\u00d6NDER\u0130ME HAZIR')) node.textContent = node.textContent.replace(/\s*\u2022\s*G\u00d6NDER\u0130ME HAZIR/g, '');
    });
  };

  const normalizeCardCopy = root => {
    const cards = [];
    const card = root?.closest?.('[data-rk5-card]');
    if (card) cards.push(card);
    root?.querySelectorAll?.('[data-rk5-card]').forEach(item => cards.push(item));

    [...new Set(cards)].forEach(item => {
      item.querySelectorAll('[data-rk5-add-button] span').forEach(label => {
        const copy = label.textContent.trim();
        if (copy === 'SEPETE EKLE') label.textContent = 'Sepete ekle';
        if (copy === 'T\u00dcKEND\u0130') label.textContent = 'T\u00fckendi';
      });
      item.querySelectorAll('[data-rk5-buy]').forEach(button => {
        const copy = button.textContent.trim();
        if (copy === 'SATIN AL') button.textContent = 'Sat\u0131n al';
        if (copy === 'HAZIRLANIYOR\u2026') button.textContent = 'Haz\u0131rlan\u0131yor\u2026';
      });
    });
  };

  const hydrateCardRatings = root => {
    const ratings = [];
    if (root?.matches?.('[data-rk5-rating]')) ratings.push(root);
    root?.querySelectorAll?.('[data-rk5-rating]').forEach(node => ratings.push(node));

    ratings.forEach(node => {
      if (node.dataset.rk5RatingReady === 'true') return;
      node.dataset.rk5RatingReady = 'true';

      let summary = null;
      try {
        summary = JSON.parse(node.dataset.summary || 'null');
        if (typeof summary === 'string') summary = JSON.parse(summary);
      } catch {
        summary = null;
      }

      const count = Number(summary?.reviewCount || 0);
      const average = Number(summary?.reviewAverageValue || 0);
      const copy = node.querySelector('[data-rk5-rating-copy]');
      const stars = node.querySelector('[data-rk5-stars]');

      if (count > 0 && average > 0) {
        const safeAverage = Math.min(5, Math.max(0, average));
        stars?.style.setProperty('--rk5-rating', `${safeAverage / 5 * 100}%`);
        if (copy) copy.textContent = `${safeAverage.toFixed(1)} (${count})`;
        node.setAttribute('aria-label', `${safeAverage.toFixed(1)} puan, ${count} de\u011ferlendirme`);
      } else {
        if (copy) copy.textContent = 'Yeni \u00fcr\u00fcn';
        node.setAttribute('aria-label', 'Hen\u00fcz de\u011ferlendirme yok');
      }
    });
  };

  const initProductPolish = root => {
    const products = [];
    if (root?.matches?.('[data-rk4-product]')) products.push(root);
    root?.querySelectorAll?.('[data-rk4-product]').forEach(section => products.push(section));

    [...new Set(products)].forEach(section => {
      if (section.dataset.rk6PolishReady === 'true') return;
      section.dataset.rk6PolishReady = 'true';

      let variants = [];
      try {
        variants = JSON.parse(section.querySelector('[data-rk4-variants]')?.textContent || '[]');
      } catch {
        variants = [];
      }

      const syncExtras = () => {
        const variantId = String(section.querySelector('[data-rk4-variant-id]')?.value || '');
        const variant = variants.find(item => String(item.id) === variantId);
        if (!variant) return;

        section.querySelectorAll('[data-rk6-sale-percent]').forEach(node => {
          node.textContent = String(variant.salePercent || 0);
        });
        section.querySelectorAll('[data-rk6-saving]').forEach(node => {
          node.textContent = variant.savingsFormatted || '';
        });
        section.querySelectorAll('[data-rk6-saving-box],[data-rk6-media-sale]').forEach(node => {
          node.hidden = !(Number(variant.salePercent) > 0);
        });
        section.querySelectorAll('[data-rk6-installment-amount]').forEach(node => {
          node.textContent = variant.installmentFormatted || '';
        });

        const sku = section.querySelector('[data-rk6-sku]');
        if (sku) sku.textContent = variant.sku || '';
      };

      section.querySelectorAll('[data-rk4-value]').forEach(button => {
        button.addEventListener('click', () => window.setTimeout(syncExtras, 0));
      });

      section.querySelectorAll('[data-rk4-thumb]').forEach(thumb => {
        thumb.addEventListener('click', () => {
          thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });

      section.querySelector('[data-rk6-reviews-jump]')?.addEventListener('click', () => {
        document.querySelector('.rk4-apps')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });

      syncExtras();
    });
  };

  const sizeFinderMap = [
    { size: 19, inner: 12.1 },
    { size: 20, inner: 12.7 },
    { size: 21, inner: 13.4 },
    { size: 22, inner: 14.0 },
    { size: 23, inner: 14.7 },
    { size: 24, inner: 15.3 },
    { size: 25, inner: 16.0 },
    { size: 26, inner: 16.7 },
    { size: 27, inner: 17.3 },
    { size: 28, inner: 18.0 },
    { size: 29, inner: 18.7 },
    { size: 30, inner: 19.3 },
    { size: 31, inner: 20.0 },
    { size: 32, inner: 20.7 },
    { size: 33, inner: 21.3 },
    { size: 34, inner: 22.0 },
    { size: 35, inner: 22.7 },
    { size: 36, inner: 23.3 },
    { size: 37, inner: 24.0 },
    { size: 38, inner: 24.7 },
    { size: 39, inner: 25.3 },
    { size: 40, inner: 26.0 }
  ];

  const sizeFinderProductCache = new Map();
  const fetchSizeFinderCollection = handle => {
    if (!sizeFinderProductCache.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      const request = (async () => {
        const products = [];
        for (let page = 1; ; page++) {
          const response = await fetch(`${root}collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('fit-catalog');
          const data = await response.json();
          const batch = Array.isArray(data.products) ? data.products : [];
          products.push(...batch);
          if (batch.length < 250) return products;
        }
      })();
      sizeFinderProductCache.set(handle, request);
      request.catch(() => sizeFinderProductCache.delete(handle));
    }
    return sizeFinderProductCache.get(handle);
  };

  const sizeFinderVariant = (product, size) => {
    const expected = String(size);
    return (product?.variants || []).find(variant => {
      if (!variant.available) return false;
      return [variant.option1, variant.option2, variant.option3].some(value => {
        const copy = String(value || '').trim();
        return copy === expected || copy.split(/\D+/).filter(Boolean).includes(expected);
      });
    });
  };

  const sizeFinderMatches = async size => {
    const candidates = await fetchSizeFinderCollection('all');
    return candidates.map(product => ({
      product,
      variant: sizeFinderVariant(product, size)
    })).filter(match => match.variant);
  };

  let sizeFinderDialog;
  let sizeFinderSupportHref = '/pages/contact';

  const buildSizeFinder = () => {
    if (sizeFinderDialog?.isConnected) return sizeFinderDialog;

    const existing = document.querySelector('[data-rk4-size-finder]');
    if (existing) {
      sizeFinderDialog = existing;
      return existing;
    }

    const dialog = document.createElement('dialog');
    dialog.id = 'RockySizeFinder';
    dialog.className = 'rk4-size-finder';
    dialog.dataset.rk4SizeFinder = '';
    dialog.setAttribute('aria-labelledby', 'RockySizeFinderTitle');
    dialog.innerHTML = `
      <div class="rk4-size-finder__shell">
        <header class="rk4-size-finder__head">
          <div class="rk4-size-finder__head-mark" aria-hidden="true"><i></i><i></i><i></i></div>
          <div>
            <p>ROCKY FIT LAB</p>
            <h2 id="RockySizeFinderTitle">Aya\u011f\u0131n\u0131 \u00f6l\u00e7, Rocky'ni bul</h2>
          </div>
          <button class="rk4-size-finder__close" type="button" data-rk4-size-finder-close aria-label="Beden bulucuyu kapat">\u00d7</button>
        </header>

        <div class="rk4-size-finder__body">
          <form class="rk4-size-finder__form">
<fieldset class="rk4-size-finder__step rk4-size-finder__measure">
              <legend><span>01</span> Ayak uzunlu\u011fu</legend>
              <div class="rk4-size-finder__measure-head">
                <p>Topuktan en uzun parma\u011fa kadar \u00f6l\u00e7.</p>
                <output data-rk4-fit-output for="RockyFootLength">19,0 cm</output>
              </div>
              <div class="rk4-size-finder__range">
                <button type="button" data-rk4-fit-step="-0.1" aria-label="Ayak uzunlu\u011funu azalt">\u2212</button>
                <input id="RockyFootLength" type="range" min="11" max="25" step="0.1" value="19" aria-label="Ayak uzunlu\u011fu santimetre">
                <button type="button" data-rk4-fit-step="0.1" aria-label="Ayak uzunlu\u011funu art\u0131r">+</button>
              </div>
              <div class="rk4-size-finder__range-scale" aria-hidden="true"><span>11 cm</span><i></i><i></i><i></i><i></i><i></i><span>25 cm</span></div>
            </fieldset>

<details class="rk4-size-finder__guide">
              <summary>Do\u011fru \u00f6l\u00e7\u00fcm nas\u0131l yap\u0131l\u0131r?</summary>
              <ol>
                <li>\u00c7ocu\u011fun aya\u011f\u0131n\u0131 ak\u015fam saatlerinde, \u00e7orapl\u0131 halde d\u00fcz ka\u011f\u0131da bast\u0131r.</li>
                <li>Topuk ve en uzun parmak ucunu i\u015faretleyip aradaki mesafeyi \u00f6l\u00e7.</li>
                <li>\u0130ki aya\u011f\u0131 da \u00f6l\u00e7; daha uzun olan de\u011feri kullan.</li>
              </ol>
            </details>
          </form>

          <aside class="rk4-size-finder__result" aria-live="polite">
            <div class="rk4-size-finder__result-top">
              <span>CANLI \u00d6NER\u0130</span>
              <span data-rk4-fit-mode-label>G\u00fcnl\u00fck hareket</span>
            </div>
            <div class="rk4-size-finder__fit-line" aria-hidden="true">
              <i></i><i></i><i></i><i></i><i></i><i></i><i></i>
              <b data-rk4-fit-marker></b>
            </div>
            <p class="rk4-size-finder__result-kicker">\u00d6nerilen ayakkab\u0131 numaras\u0131</p>
            <div class="rk4-size-finder__number"><strong data-rk4-fit-size>31</strong><span>NUMARA</span></div>
            <div class="rk4-size-finder__result-meta">
              <span data-rk4-fit-length-label>19,0 cm ayak</span>
              <span data-rk4-fit-allowance-label>+0,8 cm hareket pay\u0131</span>
            </div>
            <p class="rk4-size-finder__result-note" data-rk4-fit-note>G\u00fcn boyu rahat kullan\u0131m i\u00e7in yakla\u015f\u0131k \u00f6neri.</p>
            <div class="rk4-size-finder__matches" data-rk4-fit-matches aria-live="polite"></div>
            <a class="rk4-size-finder__primary" data-rk4-fit-collection href="/collections/yeni-sezon"><span data-rk4-fit-collection-label>Uygun modelleri g\u00f6r</span></a>
            <a class="rk4-size-finder__secondary" data-rk4-fit-support href="/pages/contact">Beden uzman\u0131na sor</a>
            <small class="rk4-size-finder__disclaimer">Bu sonu\u00e7 ba\u015flang\u0131\u00e7 \u00f6nerisidir. Model kal\u0131b\u0131n\u0131 \u00fcr\u00fcn sayfas\u0131ndaki beden tablosundan do\u011frula.</small>
          </aside>
        </div>
      </div>
    `;

    document.body.append(dialog);
    sizeFinderDialog = dialog;

    const range = dialog.querySelector('#RockyFootLength');
    const output = dialog.querySelector('[data-rk4-fit-output]');
    const size = dialog.querySelector('[data-rk4-fit-size]');
    const marker = dialog.querySelector('[data-rk4-fit-marker]');
    const lengthLabel = dialog.querySelector('[data-rk4-fit-length-label]');
    const allowanceLabel = dialog.querySelector('[data-rk4-fit-allowance-label]');
    const modeLabel = dialog.querySelector('[data-rk4-fit-mode-label]');
    const note = dialog.querySelector('[data-rk4-fit-note]');
    const matches = dialog.querySelector('[data-rk4-fit-matches]');
    const collection = dialog.querySelector('[data-rk4-fit-collection]');
    const collectionLabel = dialog.querySelector('[data-rk4-fit-collection-label]');
    const support = dialog.querySelector('[data-rk4-fit-support]');
    let matchRequest = 0;
    let matchTimer = 0;

    const productImage = (product, variant) => {
      const image = variant?.featured_image || product?.featured_image || product?.images?.[0];
      return typeof image === 'string' ? image : image?.src || '';
    };

    const productPrice = variant => new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'TRY',
      minimumFractionDigits: Number(variant?.price) % 1 ? 2 : 0,
      maximumFractionDigits: 2
    }).format(Number(variant?.price || 0));

    const renderMatches = async ({ size: recommendedSize }) => {
      const request = ++matchRequest;
      matches.setAttribute('aria-busy', 'true');
      matches.innerHTML = '<p class="rk4-size-finder__match-status">Stoktaki uygun modeller aran\u0131yor\u2026</p>';

      let found;
      try { found = await sizeFinderMatches(recommendedSize); }
      catch {
        if (request !== matchRequest) return;
        matches.removeAttribute('aria-busy');
        matches.textContent = 'Modeller yüklenemedi. Ölçüyü değiştirerek tekrar deneyebilirsin.';
        return;
      }
      if (request !== matchRequest) return;

      matches.replaceChildren();
      matches.removeAttribute('aria-busy');
      if (!found.length) {
        const empty = document.createElement('p');
        empty.className = 'rk4-size-finder__match-status is-empty';
        empty.textContent = `${recommendedSize} numarada stokta model bulunamad\u0131.`;
        matches.append(empty);
        collection.href = `${window.Shopify?.routes?.root || '/'}collections/all`;
        collectionLabel.textContent = 'Koleksiyonu incele';
        return;
      }

      found.forEach(({ product, variant }) => {
        const card = document.createElement('a');
        card.className = 'rk4-size-finder__match';
        card.href = `/products/${product.handle}?variant=${variant.id}`;

        const imageUrl = productImage(product, variant);
        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = product.title || '';
          image.loading = 'lazy';
          card.append(image);
        }

        const copy = document.createElement('span');
        const stock = document.createElement('small');
        stock.textContent = `${recommendedSize} numara stokta`;
        const title = document.createElement('strong');
        title.textContent = product.title || 'Rocky';
        const price = document.createElement('b');
        price.textContent = productPrice(variant);
        copy.append(stock, title, price);
        card.append(copy);
        matches.append(card);
      });

      collection.href = `${window.Shopify?.routes?.root || '/'}collections/all?view=rocky-match&rocky_size=${recommendedSize}&rocky_stock=1`;
      collectionLabel.textContent = `${recommendedSize} numaradaki tüm eşleşmeleri incele (${found.length})`;
    };

    const scheduleMatches = state => {
      window.clearTimeout(matchTimer);
      matchTimer = window.setTimeout(() => renderMatches(state), 140);
    };

    const syncResult = () => {
      const footLength = Number(range.value);
      const allowance = 0.8;
      const targetLength = footLength + allowance;
      const match = sizeFinderMap.find(item => item.inner >= targetLength) || sizeFinderMap[sizeFinderMap.length - 1];
      const formattedLength = footLength.toFixed(1).replace('.', ',');
      const formattedAllowance = allowance.toFixed(1).replace('.', ',');
      const progress = (footLength - Number(range.min)) / (Number(range.max) - Number(range.min)) * 100;

      output.textContent = `${formattedLength} cm`;
      size.textContent = String(match.size);
      lengthLabel.textContent = `${formattedLength} cm ayak`;
      allowanceLabel.textContent = `+${formattedAllowance} cm hareket pay\u0131`;
      modeLabel.textContent = 'Ayak uzunluğuna göre';
      note.textContent = 'Ayak uzunluğuna göre yaklaşık numara önerisi.';
      collection.href = `${window.Shopify?.routes?.root || '/'}collections/all`;
      collectionLabel.textContent = 'Uygun modelleri g\u00f6r';
      marker.style.setProperty('--rk4-fit-position', `${Math.min(100, Math.max(0, progress))}%`);
      scheduleMatches({ size: match.size });
    };

    range.addEventListener('input', syncResult);
    dialog.querySelectorAll('[data-rk4-fit-step]').forEach(button => {
      button.addEventListener('click', () => {
        const value = Math.min(Number(range.max), Math.max(Number(range.min), Number(range.value) + Number(button.dataset.rk4FitStep)));
        range.value = value.toFixed(1);
        syncResult();
      });
    });

    const close = () => dialog.close();
    dialog.querySelector('[data-rk4-size-finder-close]').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('close', () => document.body.classList.remove('rk4-size-finder-open'));
    dialog.addEventListener('cancel', () => document.body.classList.remove('rk4-size-finder-open'));
    support.href = sizeFinderSupportHref;
    syncResult();
    return dialog;
  };

  const openSizeFinder = async () => {
    const dialog = buildSizeFinder();
    await rk4FitLabCssReady;
    dialog.querySelector('[data-rk4-fit-support]').href = sizeFinderSupportHref;
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('rk4-size-finder-open');
  };

  const initSizeFinder = root => {
    /* The header renders the final trigger server-side (sections/rk4-header.liquid); just pick up its support URL. */
    const serverTrigger = root?.matches?.('[data-rk4-support-href]') ? root : root?.querySelector?.('[data-rk4-support-href]');
    if (serverTrigger) sizeFinderSupportHref = serverTrigger.getAttribute('data-rk4-support-href') || sizeFinderSupportHref;

    /* Legacy fallback: only runs if an old cached header still ships the plain "Beden destegi" link. */
    const headerLinks = [];
    if (root?.matches?.('.rk4-header__support:not([data-rk4-size-finder-open])')) headerLinks.push(root);
    root?.querySelectorAll?.('.rk4-header__support:not([data-rk4-size-finder-open])').forEach(link => headerLinks.push(link));

    headerLinks.forEach(link => {
      sizeFinderSupportHref = link.getAttribute('href') || sizeFinderSupportHref;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rk4-header__support rk4-size-trigger';
      button.dataset.rk4SizeFinderOpen = '';
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', 'RockySizeFinder');
      button.setAttribute('aria-label', 'Numaran\u0131 bul');
      button.innerHTML = '<svg class="rk4-size-trigger__icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M3 17h18M5 17V9l4 1 3 3h6a3 3 0 0 1 3 3v1M7 13l1.5-1.5M10 15l1.5-1.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="rk4-size-trigger__label">Numaran\u0131 bul</span>';
      link.replaceWith(button);
    });

    const mobileLinks = [];
    root?.querySelectorAll?.('.rk4-mobile-menu__utilities a').forEach(link => {
      if (link.textContent.toLocaleUpperCase('tr-TR').includes('BEDEN')) mobileLinks.push(link);
    });
    mobileLinks.forEach(link => {
      sizeFinderSupportHref = link.getAttribute('href') || sizeFinderSupportHref;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rk4-size-mobile-trigger';
      button.dataset.rk4SizeFinderOpen = '';
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', 'RockySizeFinder');
      button.innerHTML = '<span>ROCKY FIT LAB</span><strong>Numaran\u0131 bul</strong>';
      link.replaceWith(button);
    });

    if (!document.documentElement.dataset.rk4SizeFinderBound) {
      document.documentElement.dataset.rk4SizeFinderBound = 'true';
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-rk4-size-finder-open]');
        if (!trigger) return;
        event.preventDefault();
        openSizeFinder();
      });
    }
  };

  /* Header/dock openers are server-rendered in their final form (data-rk4-mobile-polished="true"), so this is a no-op for them. */
  const initMobileNavigationPolish = root => {
    const openers = [];
    if (root?.matches?.('[data-rk4-mobile-open]')) openers.push(root);
    root?.querySelectorAll?.('[data-rk4-mobile-open]').forEach(button => openers.push(button));
    openers.forEach(button => {
      if (button.dataset.rk4MobilePolished === 'true') return;
      button.dataset.rk4MobilePolished = 'true';
      button.classList.add('rk4-mobile-open--polished');
      const label = document.createElement('span');
      label.className = 'rk4-mobile-open__label';
      label.setAttribute('aria-hidden', 'true');
      label.textContent = 'Men\u00fc';
      button.append(label);
    });

    const menus = [];
    if (root?.matches?.('[data-rk4-mobile-menu]')) menus.push(root);
    root?.querySelectorAll?.('[data-rk4-mobile-menu]').forEach(menu => menus.push(menu));
    menus.forEach(menu => {
      if (menu.dataset.rk4MenuPolished !== 'true') menu.dataset.rk4MenuPolished = 'true';
      const glass = menu.querySelector('.rk4-mobile-menu__glass');
      const utilities = menu.querySelector('.rk4-mobile-menu__utilities');
      if (!glass || !utilities || glass.querySelector('.rk4-mobile-menu__confidence')) return;

      const confidence = document.createElement('section');
      confidence.className = 'rk4-mobile-menu__confidence';
      confidence.setAttribute('aria-label', 'Rocky al\u0131\u015fveri\u015f g\u00fcvencesi');

      const head = document.createElement('div');
      head.className = 'rk4-mobile-menu__confidence-head';
      const eyebrow = document.createElement('span');
      eyebrow.textContent = 'ROCKY G\u00dcVENCES\u0130';
      const title = document.createElement('strong');
      title.textContent = 'Her ad\u0131mda yan\u0131nda';
      head.append(eyebrow, title);

      const list = document.createElement('div');
      list.className = 'rk4-mobile-menu__confidence-list';
      [
        ['01', 'Do\u011fru beden deste\u011fi', 'Fit Lab ile 60 saniyede \u00f6neri'],
        ['02', 'G\u00fcvenli \u00f6deme', 'Shopify \u00f6deme altyap\u0131s\u0131'],
        ['03', 'Sipari\u015f takibi', 'Hesab\u0131ndan kolayca kontrol et']
      ].forEach(([number, heading, copy]) => {
        const item = document.createElement('div');
        item.className = 'rk4-mobile-menu__confidence-item';
        const index = document.createElement('b');
        index.textContent = number;
        const text = document.createElement('span');
        const itemTitle = document.createElement('strong');
        itemTitle.textContent = heading;
        const itemCopy = document.createElement('small');
        itemCopy.textContent = copy;
        text.append(itemTitle, itemCopy);
        item.append(index, text);
        list.append(item);
      });

      confidence.append(head, list);
      utilities.insertAdjacentElement('afterend', confidence);
    });
  };

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'characterData') {
        safeStockCopy(mutation.target.parentElement);
        normalizeCardCopy(mutation.target.parentElement);
        hydrateCardRatings(mutation.target.parentElement);
      } else {
        safeStockCopy(mutation.target);
        normalizeCardCopy(mutation.target);
        hydrateCardRatings(mutation.target);
      }
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        safeStockCopy(node);
        normalizeCardCopy(node);
        hydrateCardRatings(node);
        mediaShells(node);
        initProductPolish(node);
        initSizeFinder(node);
        initMobileNavigationPolish(node);
      });
    });
  });

  const init = () => {
    safeStockCopy(document);
    normalizeCardCopy(document);
    hydrateCardRatings(document);
    mediaShells(document);
    initProductPolish(document);
    initSizeFinder(document);
    initMobileNavigationPolish(document);
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    window.addEventListener('load', () => safeStockCopy(document), { once: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
